<template>
    <ClientOnly class="layout-infinite-scroll" v-if="hasMore && loadMore">
        <InfiniteLoading @infinite="loadMore" :firstload="firstLoad === undefined || firstLoad" target="scroll"></InfiniteLoading>
        <LoadingWidget></LoadingWidget>
    </ClientOnly>
</template>

<script setup lang="ts">
defineProps(['hasMore', 'loadMore', 'firstLoad']);

const infinite = usePluginInfinite();
await infinite.init();
</script>
